module.exports = {
  REFUND: 'refund',
  DEPOSIT: 'deposit'
}
